module.exports = __webpack_public_path__ + "img/selected6-min.758b82f9.png";